(ns ycweb.app.dashboard.common
  (:require
    [rum.core :as rum]))

(rum/defcs hover-tooltip < rum/reactive (rum/local {:hover nil} ::local)
  [s body tooltip & [{:keys [translate]}]]
  (let [local-atom (::local s)
        {:keys [hover]} (rum/react local-atom)]
    [:span
     {:on-mouse-over
      (fn [e]
        (swap! local-atom assoc :hover [(.-pageX e) (.-pageY e)]))
      :on-mouse-out
      (fn [e]
        (swap! local-atom dissoc :hover))}
     body
     (when hover
       [:div.u-text-left
        {:style
         {:position "absolute" :left (first hover) :top (second hover)
          :transform (str "translate(" (or translate "-120%,-50%") ")")}}
        tooltip])]))

;; TODO: This will not be needed in future versions where we can control the entire dashboard
;; as a holistic component.
(defn kill-search-bar []
  #?(:cljs
     (do
       #_(doseq [e (.getElementsByClassName js/document "admin-nav")]
           (set! (.-style e) "display:none"))

       (doseq [e (array-seq (.getElementsByClassName js/document "admin-search-wrapper"))]
         (set! (.-style e) "display:none"))

       #_(doseq [e (.getElementsByClassName js/document "admin-page-body")]
           (set! (.-style e) "padding-left:10px")))))